module.exports = __webpack_public_path__ + "img/image167.e3db4c89.jpg";